export default "/images/play.svg?f874f1e6f50885e6128a0b03f8d8aca1";